import React from 'react';
import { FileTextIcon } from 'lucide-react';
export function TSeriesSection() {
  return <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-886">
      <div className="bg-[#002d4d] text-white py-6 px-8 flex flex-col md:flex-row md:items-center justify-between" data-id="element-887">
        <div data-id="element-888">
          <h2 className="text-3xl font-bold mb-1" data-id="element-889">Bodor T Series</h2>
          <h3 className="text-white/80 font-medium text-lg" data-id="element-890">
            Versatile Fiber Laser Tube Cutting Machine
          </h3>
        </div>
      </div>

      <div className="p-8" data-id="element-891">
        <div className="grid md:grid-cols-12 gap-12 items-center mb-10" data-id="element-892">
          <div className="md:col-span-5 flex flex-col items-center bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-893">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/BODOR/Laser%20Tube%20Cutter/Bodor%20T%20Series%20Laser%20Tube%20Cutting%20Machine.PNG" alt="Bodor T Series" className="block max-h-[350px] w-auto object-contain drop-shadow-xl mb-4" data-id="element-894" />
            <span className="bg-[#f5693d] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider text-center" data-id="element-895">
              Bigger than Bigger
            </span>
          </div>
          <div className="md:col-span-7" data-id="element-896">
            <p className="text-gray-700 text-lg mb-6 bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-897">
              The maximum cutting diameter of T series is 30% longer than the
              mainstream products in the market; The maximum cutting weight is
              100% heavier than the mainstream products in the market.
            </p>
            <ul className="space-y-4 text-gray-700" data-id="element-898">
              <li data-id="element-899">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-900">
                  Chuck position control, torque control function
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-901">
                  The position control CNC self-centering chuck with independent
                  intellectual property rights can automatically clamp material
                  according to the input tube size; Position monitoring in
                  torque mode to ensure that the thick tube is not loosened and
                  the small tube is not deformed; Brand new dust-proof
                  structure, long-lasting use without lagging.
                </span>
              </li>
              <li data-id="element-902">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-903">
                  Edge-seeking, center-finding
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-904">
                  Brand new function of edge-seeking, center-finding. Optimized
                  edge-finding method and algorithm, higher cutting precision
                  and stability.
                </span>
              </li>
              <li data-id="element-905">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-906">
                  Touch Control
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-907">
                  The first one to use UI design in the world which lets display
                  respond to processing table, making processing more intuitive.
                  1920*1080 high-definition capacitive 10 points touch screen.
                  Elegant curves precisely fit machine body. Strong waterproof
                  breathable system creates the best space, making operation
                  more convenient. Diamond cutting process and HD plasma
                  tempered glass make screen more exquisite and comfortable to
                  use.
                </span>
              </li>
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 mt-8 pt-6 border-t border-gray-100" data-id="element-908">
              <a href="https://www.peakedm.com/m7/Bodor%20T%20Series--t-series-performance-fiber-laser-tube-cutting-machine.html" className="inline-flex items-center justify-center px-6 py-3 bg-[#002d4d] text-white font-bold uppercase text-sm rounded-md hover:bg-[#f5693d] transition-colors" data-id="element-909">
                <span className="mr-2" data-id="element-910">+</span> Discover More
              </a>
              <a href="https://www.peakedm.com/uploaded/files/Bodor%20Files/Brochure%20Bodor%20T%20series%20Fiber%20Laser%20Tube%20Cutter.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border-2 border-[#002d4d] text-[#002d4d] font-bold uppercase text-sm rounded-md hover:bg-[#002d4d] hover:text-white transition-colors" data-id="element-911">
                <FileTextIcon className="w-4 h-4 mr-2" data-id="element-912" /> Download Brochure
              </a>
            </div>
          </div>
        </div>

        <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm" data-id="element-913">
          <table className="w-full text-sm text-left text-gray-600" data-id="element-914">
            <thead className="text-xs text-gray-700 uppercase bg-gray-100 border-b border-gray-200" data-id="element-915">
              <tr data-id="element-916">
                <th scope="col" className="px-6 py-4 font-bold border-r border-gray-200 w-1/3" data-id="element-917">
                  Model
                </th>
                <th scope="col" className="px-6 py-4 font-bold text-center border-r border-gray-200 w-1/3" data-id="element-918">
                  T230
                </th>
                <th scope="col" className="px-6 py-4 font-bold text-center w-1/3" data-id="element-919">
                  T360
                </th>
              </tr>
            </thead>
            <tbody data-id="element-920">
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-921">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-922">
                  Effective Tube Cutting Length
                </th>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-923">
                  6500mm/9200mm
                </td>
                <td className="px-6 py-4 text-center" data-id="element-924">6500mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-925">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-926">
                  Laser Power
                </th>
                <td colSpan={2} className="px-6 py-4 text-center" data-id="element-927">
                  6000w/3000w/2000w/1500w
                </td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-928">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-929">
                  Round Tube Cutting Diameter
                </th>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-930">
                  Φ20-230mm
                </td>
                <td className="px-6 py-4 text-center" data-id="element-931">Φ20-360mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-932">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-933">
                  Square Tube Cutting
                </th>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-934">
                  □20*20-□160*160mm
                </td>
                <td className="px-6 py-4 text-center" data-id="element-935">□20*20-□254*254mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-936">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-937">
                  Rectangular Tube Edge Length
                </th>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-938">
                  20-170mm
                </td>
                <td className="px-6 py-4 text-center" data-id="element-939">20-300mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-940">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-941">
                  Rectangular Tube Outer Circle Dia
                </th>
                <td className="px-6 py-4 text-center border-r border-gray-200" data-id="element-942">
                  ≤230mm
                </td>
                <td className="px-6 py-4 text-center" data-id="element-943">≤360mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-944">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-945">
                  Positioning accuracy
                </th>
                <td colSpan={2} className="px-6 py-4 text-center" data-id="element-946">
                  0.05mm
                </td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-947">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-948">
                  Repositioning accuracy
                </th>
                <td colSpan={2} className="px-6 py-4 text-center" data-id="element-949">
                  0.03mm
                </td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-950">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-951">
                  X axis max speed
                </th>
                <td colSpan={2} className="px-6 py-4 text-center" data-id="element-952">
                  100m/min
                </td>
              </tr>
              <tr className="bg-white hover:bg-gray-50" data-id="element-953">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-954">
                  Y axis max speed
                </th>
                <td colSpan={2} className="px-6 py-4 text-center" data-id="element-955">
                  95m/min
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}